import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

type UseCompetitionListQueryParams = Parameters<typeof SSF.api.competitionsList>[0];

export const keys = createQueryKeySet<UseCompetitionListQueryParams>('competitions');

export function useCompetitionListQuery(params?: UseCompetitionListQueryParams) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.competitionsList(params);
      return data;
    },
    queryKey: keys.list(params),
  });
}

export function useCompetitionQuery(id: number) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.competitionsRetrieve(id);
      return data;
    },
    queryKey: keys.detail(id),
  });
}
